import { useScrollProgress } from '../utility/motion';
import Text from '../utility/Text';

const CAREER_START = new Date(2019, 10, 1);

const yearsSince = (date) => {
    const now = new Date();
    let years = now.getFullYear() - date.getFullYear();
    if (now.getMonth() < date.getMonth() || (now.getMonth() === date.getMonth() && now.getDate() < date.getDate())) {
        years -= 1;
    }
    return years;
};

function ScrollStatement({text}) {
    const [ref, progress] = useScrollProgress();
    const words = text.split(' ');
    return (
        <p className="statement" ref={ref}>
            {words.map((word, index) => {
                const threshold = index / words.length;
                return (
                    <span
                        key={`${word}-${index}`}
                        className={`statement__word ${progress > threshold ? 'is-lit' : ''}`}
                    >
                        {word}{' '}
                    </span>
                );
            })}
        </p>
    );
}

function About({content, checked}) {
    const experience = yearsSince(CAREER_START);
    const age = yearsSince(new Date(Text.myBirthday));

    const statement = checked
        ? 'Scrivo software che regge il peso del lavoro vero: backend robusti di giorno, app e siti curati nel tempo libero.'
        : 'I write software that carries real-world weight: robust backends by day, polished apps and websites in my spare time.';

    const stats = [
        { value: `${experience}+`, label: checked ? 'anni di esperienza' : 'years of experience' },
        { value: age, label: checked ? 'anni, da Roma' : 'years old, from Rome' },
        { value: '∞', label: checked ? 'idee in sviluppo' : 'ideas in progress' },
    ];

    const timeline = [
        {
            period: checked ? '2021 — oggi' : '2021 — now',
            title: 'Softlab s.p.a.',
            role: 'Java Backend · Senior Consultant',
            current: true,
        },
        {
            period: '2019 — 2021',
            title: 'Prisma s.r.l.',
            role: 'Junior Java Backend Developer',
        },
        {
            period: '2014 — 2019',
            title: 'ITIS Pacinotti Archimede',
            role: checked ? 'Diploma in informatica, Roma' : 'Computer science diploma, Rome',
        },
    ];

    return (
        <section className="section about" id="about-me" aria-labelledby="about-title">
            <div className="section__head" data-reveal>
                <span className="eyebrow"><span className="eyebrow__index">01</span>{checked ? 'Chi sono' : 'About me'}</span>
                <h2 className="section__title" id="about-title">
                    {checked ? 'Un po’ di me' : 'A bit about me'}
                </h2>
            </div>

            <ScrollStatement text={statement} />

            <div className="about__grid">
                <div className="about__bio card" data-reveal>
                    <p>{content}</p>
                </div>

                <div className="about__side">
                    <ul className="stats">
                        {stats.map((stat, index) => (
                            <li className="stats__item card" key={stat.label} data-reveal style={{ '--d': `${index * 90}ms` }}>
                                <span className="stats__value">{stat.value}</span>
                                <span className="stats__label">{stat.label}</span>
                            </li>
                        ))}
                    </ul>

                    <ol className="timeline">
                        {timeline.map((step, index) => (
                            <li
                                key={step.title}
                                className={`timeline__step ${step.current ? 'is-current' : ''}`}
                                data-reveal
                                style={{ '--d': `${index * 120}ms` }}
                            >
                                <span className="timeline__dot" aria-hidden="true" />
                                <span className="timeline__period mono">{step.period}</span>
                                <span className="timeline__title">{step.title}</span>
                                <span className="timeline__role">{step.role}</span>
                            </li>
                        ))}
                    </ol>
                </div>
            </div>
        </section>
    );
}

export default About;
